export const baseURL = process.env.REACT_APP_API_BASE_URL || "https://api.wikisocial.net/api";
export const ImgsUrl = "https://api.wikisocial.net/api";

export const resolveImg = (img) =>
  img?.startsWith("http") ? img : `${ImgsUrl}/${img}`;

// Auth
export const LOGIN = "loginAdmin";
// Add Admin
export const AddAdmin = "addAdmin";

// Posts And Users
export const DeleteContent = "deleteContent";
export const WarningUser = "warningUser";
export const BanUser = "banUser";

export const GetSpotted = "getSpotted";
export const GetReported = "getReportByUser";
export const GetContent = "getContentById";
